import _ from "lodash";
import store from "CommonState/store";
import {
  Component,
} from "react";
import {
  Alert,
  Button,
  Modal,
} from "react-bootstrap";
import {
  Panel,
  Spinner,
} from "CommonComponents/bricks";
import {
  formatDate,
  ReactSelectTexts,
} from "CommonCore/l10n";
import apifetch from "CommonCore/apifetch";
import Select from "App/legacy/react-select-virtualized";
import {
  getSVA_pgd_data,
} from "Apis/antrag-api";

@store(
  "k_anredeLookup",
  "k_familienstandLookup",
  "k_staatLookup",
  "k_vertragsartLookup",
  "k_anredetitelLookup",
  "k_pfaartLookup",
  "k_astat_job_graduationLookup",
  "user",
  "k_krankenkasseLookup",
)
export default class SVASuchePopup extends Component {
  /*
   * Nicht-Interaktive Variante: so viel wie möglich automatisch, keine Benutzereingaben
   * 1. nach Name, Vorname suchen
   * 2. nach Geburtsdatum suchen
   */

  constructor() {
    super();
    this.STEP = {
      NAME: 1,
      NAME_OK: 2,
      DATUM: 3,
      DATUM_OK: 4,
      NEU: 5,
      NEU_OK: 6,
    };
    this.state = { didQuery: false, query: {}, step: null, hasAdded: false };
  }

  getStepHeader() {
    const { step, result } = this.state;
    switch (step) {
      case this.STEP.NAME: return "Suche nach Name und Geburtsdatum";
      case this.STEP.NAME_OK: return result.length == 1 ? "Datensatz gefunden" : "Datensatz auswählen";
      case this.STEP.DATUM: return "Suche nach Geburtsdatum";
      case this.STEP.DATUM_OK: return result.length == 1 ? "Datensatz gefunden" : "Datensatz auswählen";
      case this.STEP.NEU: return "Datensatz neu anlegen";
      case this.STEP.NEU_OK: return "Datensatz neu anlegen";
    }
  }

  componentDidMount() {
    const { antrag } = this.props;
    if (antrag) {
      const person = antrag.antrag_person[0];
      this.setState({
        query: {
          pgd_name: person.ap_name,
          pgd_vornamen: person.ap_vorname,
          pgd_geburtsdatum: person.ap_gebdatum,
          pgd_join_id: person.ap_svakey,
        },
        person: person,
      }, this.nextStep);
    }
  }

  nextStep() {
    let { step } = this.state;
    switch (step) {
      case null:
        step = this.STEP.NAME;
        this.suchen(step, this.STEP.NAME_OK);
        break;
      case this.STEP.NAME:
        step = this.STEP.DATUM;
        this.suchen(step, this.STEP.DATUM_OK);
        break;
      case this.STEP.DATUM:
        step = this.STEP.NEU;
    }
    this.setState({ step });
  }

  render() {
    const { onCancel } = this.props;
    const { errorMessage,
            result,
            person_id,
            person,
            step,
            inflight } = this.state;

    const choices = _.map(result, pgd => {
      return { value: pgd.pgd_join_id, label: this.formatSVAPerson(pgd) };
    });
    const selectTexts = _.clone(ReactSelectTexts);
    selectTexts.placeholder = "Bitte wählen Sie die richtige Person aus";

    const formatOptionLabel = ({ label }) => (
      <div class='ellipsed-text'>{label}</div>
    );

    return (
      <Modal show onHide={onCancel}>
        <Modal.Header>
          <h2>{this.getStepHeader()}</h2>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
          {inflight && <Spinner />}

          {step == this.STEP.NEU &&
            <Panel header='Diese Person ist noch nicht in SVA erfasst, bitte neuen Datensatz anlegen'>
              {this.formatSHKPerson(person)}
            </Panel>
          }

          {step == this.STEP.NEU_OK &&
            <Panel header='Sie haben für diese Person einen neuen Datensatz angelegt'>
              {this.formatSHKPerson(person)}
            </Panel>
          }

          {!_.isEmpty(choices) && step != this.STEP.NEU_OK &&
            <Panel header={step == this.STEP.NAME_OK
? `Die Angaben passen zu ${ choices.length == 1 ? "dieser Person" : "diesen Personen" } in SVA`
              : `Es gibt ${ choices.length } Personen mit demselben Geburtsdatum:`}>
              <Select
                value={choices.filter(({ value }) => value === person_id)}
                onChange={val => this.onSelect(val && val.value ? val.value : val)}
                options={choices}
                formatOptionLabel={formatOptionLabel}
                isClearable={false}
                {...selectTexts}
              />
            </Panel>
          }
        </Modal.Body>
        <Modal.Footer>
          {(step == this.STEP.DATUM_OK || step == this.STEP.NAME_OK) &&
            <span>
              <Button variant='primary' disabled={inflight || !person_id} onClick={this.zuordnen}>
                {`${ person_id ? person_id : "" } Bestätigen`}
              </Button>
              <Button variant='outline-primary' disabled={inflight} onClick={() => this.neuanlegen(this.STEP.NEU_OK)}>
                'Neu Anlegen'
              </Button>
              <Button variant='outline-primary' onClick={onCancel} disabled={inflight}>Abbrechen</Button>
            </span>
          }
          {step == this.STEP.NEU &&
            <span>
              <Button variant='primary' onClick={() => this.neuanlegen(this.STEP.NEU_OK)}>
                Neu Anlegen
              </Button>
              <Button onClick={onCancel} disabled={inflight}>Abbrechen</Button>
            </span>
          }

          {step == this.STEP.NEU_OK &&
            <Button variant='primary' onClick={this.zuordnen}>
              Ok
            </Button>
          }

          {errorMessage && step == this.STEP.NAME &&
            <Button variant='primary' onClick={onCancel} disabled={inflight}>Ok</Button>
          }


        </Modal.Footer>
      </Modal>
    );
  }

  onSelect = val => {
    this.setState({ person_id: val });
  };

  formatSVAPerson(pgd) {
    return `${ pgd.pgd_join_id } - ${ pgd.anrede != "Unbekannt" ? `${ pgd.anrede } ` : "" }${ pgd.pgd_name },  ${ pgd.pgd_vornamen }`
      + `, geb. ${ formatDate(pgd.pgd_geburtsdatum) } in ${ pgd.pgd_geburtsort }/${ pgd.geburtsland }, ${ pgd.text_staatsangehoe }, ${ pgd.druck_familienstd } `;
  }

  formatSHKPerson(ap) {
    const { k_anredeLookup,
            k_familienstandLookup,
            k_staatLookup } = this.props;
    return `${ _.get(k_anredeLookup, [ap.ap_kanid, "kan_kbez"]) } ${ ap.ap_name },  ${ ap.ap_vorname }`
      + `, geb. ${ formatDate(ap.ap_gebdatum) } in ${ ap.ap_gebort }/${ _.get(k_staatLookup, [ap.ap_geb_ksaid, "ksa_kbez"]) }`
      + ` , ${ _.get(k_staatLookup, [ap.ap_geb_ksaid, "ksa_adjektiv"]) }, ${ _.get(k_familienstandLookup, [ap.ap_kfaid, "kfa_kbez"]) } `;
  }

  suchen = async(step, nextstep) => {
    let { query } = this.state;

    // Kriterien je nach Modus auswählen
    switch (step) {
      case this.STEP.NAME:
        query = _.pickBy(query, (value, key) => ["pgd_name", "pgd_vornamen", "pgd_geburtsdatum"].indexOf(key) >= 0);
        break;
      case this.STEP.DATUM:
        query = _.pickBy(query, (value, key) => ["pgd_geburtsdatum"].indexOf(key) >= 0);
        break;
    }

    // Query-String bauen
    const args = _.map(Object.keys(query), key => `${ key }=${ query[key] }`).join("&");

    try {
      this.setState({ inflight: true });
      const result = await apifetch("/api/shkexport/svaexport/person?" + args);

      /*
       *if (!_.isEmpty(result.data)) {
       *result.data=result.data.slice(0,1)
       *}
       */

      const data_ok = !_.isEmpty(result.data) && result.data.length == 1;

      this.setState({
        inflight: false,
        didQuery: true,
        validationErrors: null,
        result: result.data,
        person_id: data_ok ? result.data[0].pgd_join_id : null,
        besold_nr: data_ok ? result.data[0].pbv_besold_nr : null,
      });
      if (!_.isEmpty(result.data)) {
        if (result.data.length == 1) {
          this.props.onSelect && this.props.onSelect(result.data[0].pgd_join_id);
        }
        this.setState({ step: nextstep });
      } else {
        // nicht gefunden
        this.nextStep();
      }
    } catch(err) {
      this.setState({
        inflight: false,
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };

  neuanlegen = async() => {
    const { antrag } = this.props;
    const { query } = this.state;

    try {
      this.setState({ inflight: true });

      const data = getSVA_pgd_data(antrag, this.props);

      let result = await apifetch("/api/shkexport/svaexport/person", {
        method: "POST",
        body: data,
      });
      result = result.data[0].pgd_join_id;

      query.pgd_join_id = result;
      this.setState({ query: query, person_id: result, besold_nr: null, step: this.STEP.NEU_OK, inflight: false });
    } catch(err) {
      this.setState({
        inflight: false,
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };

  zuordnen = async() => {
    const { person_id, besold_nr } = this.state;
    const { antrag } = this.props;
    // Validieren
    if (!_.isNumber(person_id) || String(person_id).length > 7) {
      this.setState({ errorMessage: "Die Personalnummer muss eine bis zu 7-stellige Ganzzahl sein" });
      return false;
    }
    try {
      await apifetch("/api/shkantrag/antrag/personalnummer", {
        method: "POST",
        body: { a_id: antrag.a_id, ap_svakey: person_id, ap_sva_lbvnr: besold_nr },
      });
      this.props.onOk(person_id);
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
}

